export default class TouchPosition {
  /*
   */
  constructor(containerElement, sliderRadius, sliderTolerance) {
    this.containerElement = containerElement;
    this.sliderRadius = sliderRadius;
    this.sliderTolerance = sliderTolerance;
    this.setNewPosition({ x: 0, y: 0 }, "Up");
  }

  /*
   */
  setNewPosition(e, rotateDirection) {
    const dimensions = this.containerElement.getBoundingClientRect();
    const side = dimensions.width;
    this.center = side / 2;
    this.relativeX = e.clientX - dimensions.left;
    this.relativeY = e.clientY - dimensions.top;
    this.rotateDirection = rotateDirection;
    // console.log("rotateDirection@@", rotateDirection);
    // console.log("e", e);
    // console.log("dimensions", dimensions);
    // console.log("center", this.center);
    // console.log("relativeX", this.relativeX);
    // console.log("relativeY", this.relativeY);
  }

  /*
   */
  get sliderAngle() {
    let supplyPITimes = 0;
    switch (this.rotateDirection) {
      case "Up":
        supplyPITimes = 3 / 2;
        break;
      case "Right":
        supplyPITimes = 1;
        break;
      case "Down":
        supplyPITimes = 5 / 2;
        break;
      case "Left":
        //本來是0 但是因為可能是負值 所以要增加2PI
        supplyPITimes = 2;
        break;
    }
    // console.log("rotateDirection", this.rotateDirection);
    // console.log("supplyPITimes", supplyPITimes);
    return (Math.atan2(this.relativeY - this.center, this.relativeX - this.center) + Math.PI * supplyPITimes) % (Math.PI * 2);
    // ((Math.atan2(this.relativeY - this.center, this.relativeX - this.center) + (Math.PI * 3) / 2) % (Math.PI * 2))
  }

  /*
   */
  get isTouchWithinSliderRange() {
    const touchOffset = Math.sqrt(Math.pow(Math.abs(this.relativeX - this.center), 2) + Math.pow(Math.abs(this.relativeY - this.center), 2));
    // console.log("center", this.center);
    // console.log("touchOffset", touchOffset);
    // console.log("sliderRadius", this.sliderRadius);
    // console.log("sliderTolerance", this.sliderTolerance);
    // console.log("isTouchWithinSliderRange", Math.abs(touchOffset - this.sliderRadius) <= this.sliderTolerance);
    return Math.abs(touchOffset - this.sliderRadius) <= this.sliderTolerance;
  }

  isTouchWithinAccessableRange(degree, downLimit, upLimit) {
    // console.log(degree, downLimit, upLimit);
    if (degree >= downLimit && degree <= upLimit) {
      return true;
    } else {
      return false;
    }
  }
}
